import { render, staticRenderFns } from "./ManejoCreditosComercios.vue?vue&type=template&id=67323060"
import script from "./ManejoCreditosComercios.vue?vue&type=script&lang=js"
export * from "./ManejoCreditosComercios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports